import React, { useEffect, useState } from "react";
import { isValidURL, pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import { Image } from "antd-mobile";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { isEmpty } from "lodash";
import useCustomTranslation from "@/hooks/useTranslation";
import { isDef } from "@/util/validate";

const UserInfo: React.FC = () => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const { userInfo, isAdminType, nativeUser } = useSelector(
		(state: RootState) => state.auth
	);
	const [avatar, setAvatar] = useState(
		require("@/assets/images/icons/Avatar.png")
	);
	const [nickname, setNickname] = useState(userInfo?.nickname ?? "");
	useEffect(() => {
		if (!isAdminType) {
			if (isDef(nativeUser)) {
				if (isDef(nativeUser.avatar)) {
					setAvatar(nativeUser.avatar);
				}
				setNickname(nativeUser.name);
				return;
			}
		}
		const cover = userInfo?.cover;
		if (isDef(cover) && !isEmpty(cover)) {
			if (isValidURL(cover)) {
				setAvatar(cover);
			} else {
				setAvatar(cover); // 相对地址
			}
		}
		if (Boolean(isAdminType)) {
			setNickname(userInfo?.income?.nickname ?? "");
		}
	}, []);

	return (
		<div className={classes.userInfoWrap}>
			<div className="avatar">
				<Image
					src={avatar}
					width={38}
					height={38}
					style={{ borderRadius: "100%" }}
					fallback={
						<Image
							src={require("@/assets/images/icons/Avatar.png")}
							width={38}
							height={38}
						/>
					}
				/>
			</div>
			<div className="info">
				<div className="slogan">
					{t("Hello")}, {nickname}
				</div>
				<div className="name">{t("Admin")}</div>
			</div>
		</div>
	);
};

export default UserInfo;

const useStyles = createUseStyles({
	userInfoWrap: {
		display: "flex",
		"& .avatar": {
			display: "flex",
			justifyContent: "start",
			alignItems: "end",
			width: pxToRem(44),
			height: pxToRem(44),
			backgroundImage: `url(${require("@/assets/images/mine/circle_s.png")})`,
			backgroundRepeat: "no-repeat",
			backgroundSize: `${pxToRem(28)} ${pxToRem(32)}`,
			backgroundPosition: "top right",
		},
		"& .info": {
			display: "flex",
			flexDirection: "column",
			flex: 1,
			overflow: "hidden",
			paddingLeft: pxToRem(16),
			"& .slogan": {
				color: "#FFFFFF",
				fontSize: pxToRem(20),
				fontWeight: "600",
				lineHeight: pxToRem(25),
				marginBottom: pxToRem(4),
			},
			"& .name": {
				color: "#868FA8",
				fontSize: pxToRem(14),
				fontWeight: "500",
				lineHeight: pxToRem(22),
			},
		},
	},
});
